import type { JSX } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { ROUTES } from './routes.js';

const router = createBrowserRouter(ROUTES);

export function App(): JSX.Element {
  return <RouterProvider router={router} />;
}

/** Re-export for callers that historically imported routes from the app module. */
export { ROUTES } from './routes.js';
